module.exports = __webpack_public_path__ + "img/ic_swiper_arrow_right.59c5fd19.svg";